import React, { memo } from 'react';
import { classNames } from '../../utils/classNames';

const VARIANTS = {
	primary:
		'bg-sky-600 text-white hover:bg-sky-700 focus:ring-sky-200 disabled:bg-sky-300',
	secondary:
		'bg-white text-zinc-700 border border-zinc-200 hover:bg-zinc-50 focus:ring-zinc-200',
	danger:
		'bg-rose-600 text-white hover:bg-rose-700 focus:ring-rose-200 disabled:bg-rose-300',
};

const SIZES = {
	sm: 'h-9 px-3 text-xs',
	md: 'h-10 px-4 text-sm',
	lg: 'h-11 px-5 text-sm',
};

export const PrimaryButton = memo(function PrimaryButton({
	children,
	type = 'button',
	onClick,
	onSubmit,
	disabled = false,
	loading = false,
	variant = 'primary',
	size = 'md',
	fullWidth = false,
	className,
	icon,
}) {
	const handleClick = (event) => {
		if (disabled || loading) return;
		if (onClick) onClick(event);
	};

	return (
		<button
			type={type}
			onClick={handleClick}
			onSubmit={onSubmit}
			disabled={disabled || loading}
			className={classNames(
				'inline-flex items-center justify-center gap-2 rounded-lg font-medium shadow-sm transition',
				'focus:outline-none focus:ring-4 disabled:cursor-not-allowed',
				VARIANTS[variant] || VARIANTS.primary,
				SIZES[size] || SIZES.md,
				fullWidth && 'w-full',
				className,
			)}
		>
			{loading ? (
				<span className='h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white' />
			) : icon ? (
				<span className='inline-flex'>{icon}</span>
			) : null}
			<span>{children}</span>
		</button>
	);
});

export default PrimaryButton;